import { render, staticRenderFns } from "./DocumentsRelatedWidget.vue?vue&type=template&id=f061b196"
import script from "./DocumentsRelatedWidget.vue?vue&type=script&lang=js"
export * from "./DocumentsRelatedWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports